export default "__VITE_ASSET__29722a0a__"